import React, { useEffect, useState } from "react";
import { Form } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import toast from "react-hot-toast";
import { changeRoleApi } from "../../../api/request/team";

const EditRoleModal = ({ isOpen, setIsOpen, user, getTeamList }) => {
  const [form] = Form.useForm();
  const [roleType, setRoleType] = useState(user?.role);
  const [isLoading, setIsLoading] = useState(false);

  const roleOptions = [
    { label: "Sub Admin", value: "admin" },
    { label: "Employee", value: "employee" },
  ];

  useEffect(() => {
    if (user?.role) {
      setRoleType(user.role);
      form.setFieldsValue({ role_Type: user.role });
    }

    if (!isOpen) clear();
  }, [isOpen, user]);

  const clear = () => {
    form.resetFields();
    setRoleType(null);
  };

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const params = { user_id: user?.id, new_role: values?.role_Type };
      const { data } = await changeRoleApi(params);
      if (data?.status) {
        toast.success(data?.message);
        clear();
        getTeamList();
        setIsOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title="Change Role">
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item
          name="role_Type"
          rules={[{ required: true, message: "Please select a role" }]}
        >
          <div className="flex items-center justify-center gap-5">
            {roleOptions?.map((option) => (
              <div
                key={option.label}
                className={`w-1/2 border p-4 rounded-md cursor-pointer text-center ${
                  roleType === option.value
                    ? "border-primary border-2 text-primary"
                    : "border-gray-300"
                }`}
                onClick={() => {
                  setRoleType(option.value);
                  form.setFieldsValue({ role_Type: option.value });
                }}
              >
                <div className="flex flex-col items-center gap-2">
                  <img
                    src={`/assets/icons/${option.value}.svg`}
                    alt={option.label}
                    width={50}
                  />
                  <p className="font-bold text-[17px]">{option.label}</p>
                </div>
              </div>
            ))}
          </div>
        </Form.Item>

        <div className="text-center">
          <LoadableButton
            className="bg-secondary text-sm text-white font-medium px-8 py-2 mt-4 rounded-lg"
            type="submit"
            lable="Submit"
            isLoading={isLoading}
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default EditRoleModal;
